// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__iI6x2","savePackageButton":"ClientWallet_savePackageButton__OPWke"};